<template>
  <div class="bg-container mothers-day">
    <div class="mday-content">
      <plants class="plants"/>
      <mother-bear class="mother-bear"/>
      <div class="flowers-container">
        <flowers class="flowers"/>
        <div class="mom-names">
          <div
            v-if="mothers[0]"
            class="flower-box box1">
              <name-container :text="`${mothers[0].firstname} ${mothers[0].lastname}`"></name-container>
            </div>
          <div
            v-if="mothers[1]"
            class="flower-box box2">
              <name-container :text="`${mothers[1].firstname} ${mothers[1].lastname}`"></name-container>
            </div>
          <div
            v-if="mothers[2]"
            class="flower-box box3">
              <name-container :text="`${mothers[2].firstname} ${mothers[2].lastname}`"></name-container>
            </div>
        </div>
      </div>
    </div>
    <div class="copy-content">
      <div class="copy1">HAPPY MOTHER'S DAY</div>
      <div class="copy2 sub-copy">celebrating your unconditional</div>
      <div class="copy3"><span>L</span><img class="heartcopy" src="@/assets/images/heart.svg"><span>VE</span></div>
    </div>

    <img class="labour-love" src="@/assets/images/labour-love-5.svg">
  </div>
</template>

<script>
import { TimelineMax, Power4, Back, Power0, Power1 } from 'gsap/TweenMax'
import SplitText from '@/assets/gsap-bonus/SplitText'
import MotherBear from '@/components/MothersSlide/MotherBear.vue'
import Plants from '@/components/MothersSlide/Plants.vue'
import Flowers from '@/components/MothersSlide/Flowers.vue'
import NameContainer from '@/components/NameContainer.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MothersDaySlide',
  components: { MotherBear, Plants, Flowers, NameContainer },
  data () {
    return {
      tl: new TimelineMax(),
      tlName: new TimelineMax()
    }
  },
  computed: {
    ...mapGetters(['activeSlide']),

    mothers () {
      return this.activeSlide.mothers
    }
  },
  watch: {
    '$store.state.activeSlide' (newValue, oldValue) {
      this.tlName.seek('names')
      this.tlName.play()
    }
  },
  mounted () {
    const planta1 = this.$el.querySelector('.planta1')
    const planta2 = this.$el.querySelector('.planta2')
    const plantb1 = this.$el.querySelector('.plantb1')
    const plantb2 = this.$el.querySelector('.plantb2')
    // const plant1 = this.$el.querySelector('.plant1')
    // const plant2 = this.$el.querySelector('.plant2')
    const heart = this.$el.querySelectorAll('.heart')
    const plantc1 = this.$el.querySelectorAll('.plantc1 circle')
    const plantc2 = this.$el.querySelectorAll('.plantc2 circle')
    const flower1 = this.$el.querySelectorAll('.flower1')
    const flower2 = this.$el.querySelectorAll('.flower2')
    const flower3 = this.$el.querySelectorAll('.flower3')
    const flowers = this.$el.querySelector('.flowers')
    const bear2 = this.$el.querySelector('.bear2')
    const bear1 = this.$el.querySelector('.bear1')
    const mday = this.$el.querySelector('.mday-content')
    const copy1 = this.$el.querySelector('.copy1')
    const copy2 = this.$el.querySelector('.copy2')
    const copy3 = this.$el.querySelector('.copy3')
    const copySplit1 = new SplitText(copy1, { type: 'chars' })
    const copySplit2 = new SplitText(copy2, { type: 'chars' })
    const heartcopy = this.$el.querySelector('.heartcopy')
    const names = this.$el.querySelectorAll('.flower-box')
    const smileMom = this.$el.querySelectorAll('.smile-mom')
    const smileCub = this.$el.querySelectorAll('.smile-cub')
    // const eyes = this.$el.querySelectorAll('.eyes')

    this.tl
      .delay(1.0)
      .add('start')
      .from(mday, 1.7, { yPercent: 120, ease: Power4.easeOut }, 'start')
      .add('plant', 'start+=0.8')
      .staggerFrom([flower1, flower2, flower3], 1, { scale: 0, transformOrigin: 'center bottom', ease: Power4.easeOut }, 0.1, 'plant')
      .from(plantb1, 0.6, { scale: 0, transformOrigin: 'right center' }, 'plant')
      .from(plantb2, 0.6, { scale: 0, transformOrigin: 'left center' }, 'plant')
      .from(planta1, 0.6, { scale: 0, transformOrigin: 'right center' }, 'plant+=0.1')
      .from(planta2, 0.6, { scale: 0, transformOrigin: 'left center' }, 'plant+=0.1')
      .add('textIn', '-=0.7')
      .staggerFrom(copySplit1.chars, 1.6, { yPercent: 350, ease: Power4.easeOut }, 0.01, 'textIn')
      .staggerFrom(copySplit2.chars, 1.6, { yPercent: 350, ease: Power4.easeOut }, 0.01, 'textIn+=0.08')
      .from(copy3, 1.6, { yPercent: 250, ease: Power4.easeOut }, 'textIn+=0.2')
      .from(heartcopy, 0.5, { scale: 0, ease: Back.easeOut, transformOrigin: 'center bottom' }, 'textIn+=0.9')
      .add('loop', 'textIn+=1')
      .staggerFrom(plantc1, 0.8, { opacity: 0, scale: 0, transformOrigin: 'center center', ease: Power0.easeNone, repeat: -1, yoyo: true, repeatDelay: 0.5 }, 0, 'loop')
      .staggerFrom(plantc2, 0.8, { opacity: 0, scale: 0, transformOrigin: 'center center', ease: Power0.easeNone, repeat: -1, yoyo: true, repeatDelay: 0.5 }, 0, 'loop')
      .staggerFrom(heart, 0.8, { scale: 0, transformOrigin: 'center center' }, 0.1, 'loop+=0.8')
      .add('heartbeat')
      .staggerTo(heart, 1.2, { scale: 1.15, transformOrigin: 'center center', ease: Back.easeInOut, repeat: -1, yoyo: true }, 0.3, 'heartbeat')
      .add('bear')
      .fromTo(flowers, 2.5, {transformOrigin: 'center center', rotation: '-3'}, {rotation: '3', repeat: -1, yoyo: true, ease: Power1.easeInOut}, 0)
      .fromTo(bear2, 2.5, {transformOrigin: '100% 100%', rotation: '1.2'}, {rotation: '-1.2', repeat: -1, yoyo: true, ease: Power1.easeInOut}, 0)
      .fromTo(bear1, 2.5, {transformOrigin: '100% 100%', rotation: '-1.2'}, {rotation: '1.2', repeat: -1, yoyo: true, ease: Power1.easeInOut}, 0)
      .to(smileMom, 2.5, { scaleX: 1.1, scaleY: 0.65, xPercent: 0, yPercent: 0, ease: Power0.easeNone, repeat: -1, yoyo: true }, 0)
      .to(smileCub, 2.5, { scaleX: 1.07, scaleY: 0.7, xPercent: 0, yPercent: 0, rotation: 15, ease: Power0.easeNone, repeat: -1, yoyo: true }, 0)

    this.tlName
      .delay(1.5)
      .add('names')
      .staggerFrom(names, 0.5, { scale: 0, transformOrigin: 'center bottom' }, 0.2, 'textIn+=0.7')
  },
  beforeDestroy () {
    this.tl.kill()
  }
}
</script>

<style scoped>
.mday-content {
  position: absolute;
  width: 100vw;
  height: 100vh;
}
.bg-container {
  background: #fffdf2;
}
.mday-content .mother-bear {
  position: absolute;
  width: 32%;
  bottom: 10vh;
  left: 11vw;
}
.mday-content .plants {
  position: absolute;
  width: 84%;
  bottom: -2vh;
  left: -1vw;
}
.mday-content .flowers-container {
  position: absolute;
  width: 60%;
  right: -4vw;
  bottom: -2vh;
}
.mday-content .flowers {
  width: 100%;
}
.copy-content {
  position: absolute;
  top: 15.9vh;
  right: 3vw;
  font-size: 4.95vw;
  text-align: center;
  color: #59BEC9;
  font-family: 'Barlow', sans-serif;
  overflow: hidden;
}
.copy-content .heartcopy {
  height: 0.77em;
  margin-right: 0.09em;
}
.copy1 {
  font-weight: 500;
}
.sub-copy {
  font-size: 0.73em;
  font-weight: 300;
}
.flower-box {
  position: absolute;
  top: 19.2%;
  width: 14.5%;
  height: 24%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex-direction: column;
  font-family: 'Barlow', sans-serif;
  font-weight: 700;
  font-size: 1.7vw;
  color: #fff;
}
.box1 {
  left: 14%;
}
.box2 {
  left: 43%;
}
.box3 {
  right: 15.2%;
}
.labour-love {
  position: absolute;
  height: auto;
  width: 5.7vw;
  left: 2vw;
  bottom: 2vw;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/components/MothersSlide.vue